import { StoreVisits } from "./constants";

export const GET_MERCHANTS = "storeVisits/get_merchant";
export const GET_MERCHANTS_FAILURE = "storeVisits/get_merchant_failure";
export const SET_MERCHANT_SELECTION = "storeVisits/set_merchant";
export const SET_START_DATE = "storeVisits/set_start_date";
export const SET_END_DATE = "storeVisits/set_end_date";
export const SET_PUBLICATION_SELECTION =
  "storeVisits/set_publication_selection";
export const GET_PUBLICATIONS = "storeVisits/GET_PUBLICATIONS";
export const GET_PUBLICATIONS_FAILURE = "storeVisits/GET_PUBLICATIONS_FAILURE";
export const SYNC_QUERY_STRING = "storeVisits/SYNC_QUERY_STRING";
export const SET_QUERY_STRING = "storeVisits/SET_QUERY_STRING";
export const GET_TOP_STORES_DATA = "storeVisits/get_top_stores_data";
export const SET_TOP_STORES_DATA = "storeVisits/set_top_stores_data";
export const GET_TOP_STORES_DATA_FAILURE =
  "storeVisits/get_top_stores_data_failure";
export const CLEAR_TOP_STORES_DATA = "storeVisits/clear_top_stores_data";

export const getTopStoresData = (
  flyer_run_ids: number[],
  start_date: string,
  end_date: string
) => ({
  type: GET_TOP_STORES_DATA,
  payload: { flyer_run_ids, start_date, end_date }
});

export const getTopStoresDataFailure = () => ({
  type: GET_TOP_STORES_DATA_FAILURE
});

export const setTopStoresData = (data: StoreVisits.TopStoreData[]) => ({
  type: SET_TOP_STORES_DATA,
  payload: data
});

export const clearTopStoresData = () => ({
  type: CLEAR_TOP_STORES_DATA
});

export const getMerchants = (q?: string) => ({
  type: GET_MERCHANTS,
  payload: q
});

export const getMerchantsFailure = () => ({
  type: GET_MERCHANTS_FAILURE
});

export const setMerchantSelection = (merchantId: number) => ({
  type: SET_MERCHANT_SELECTION,
  payload: merchantId
});

export const setStartDate = (startDate: string) => ({
  type: SET_START_DATE,
  payload: startDate
});

export const setEndDate = (endDate: string) => ({
  type: SET_END_DATE,
  payload: endDate
});

export const setPublicationSelection = (publicationIds: number[]) => ({
  type: SET_PUBLICATION_SELECTION,
  payload: publicationIds
});

export const getPublications = (
  merchantId: number,
  startDate: string,
  endDate: string
) => ({
  type: GET_PUBLICATIONS,
  payload: {
    merchant_id: merchantId,
    start_date: startDate,
    end_date: endDate
  }
});

export const getPublicationsFailure = () => ({
  type: GET_PUBLICATIONS_FAILURE
});
export const setQueryString = (queryString: string) => ({
  type: SET_QUERY_STRING,
  payload: queryString
});

export const syncQueryString = (queryString: string) => ({
  type: SYNC_QUERY_STRING,
  payload: {
    queryString: queryString
  }
});



// WEBPACK FOOTER //
// ./client/modules/StoreVisits/actions.ts